/*
 * @Author: lan.h
 * @Date: 2021-10-14 09:39:50
 * @LastEditors: lan.h
 * @LastEditTime: 2021-11-30 15:26:43
 * @Description: main
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filter from './assets/js/filter'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

for(let key in filter){
  Vue.filter(key, filter[key])
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
